import { render } from "./MirrorProcessing.vue?vue&type=template&id=2f66b072&scoped=true"
import script from "./MirrorProcessing.vue?vue&type=script&lang=js"
export * from "./MirrorProcessing.vue?vue&type=script&lang=js"

import "./MirrorProcessing.vue?vue&type=style&index=0&id=2f66b072&scoped=true&lang=css"
/* custom blocks */
import block0 from "./MirrorProcessing.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f66b072"]])

export default __exports__